module.exports = __webpack_public_path__ + "static/img/img-install-tag-car-grid-detail.fea2351.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-car-grid-detail.svg
// module id = 1788
// module chunks = 1